import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getCashinAndCashout } from 'services/financialHistory'

export default function useGetCashinCashout() {
    const { poolship } = useParams()
    const { data, isLoading } = useQuery(
        ['financial-history-cashin-cashout', poolship],
        getCashinAndCashout
    )
    return { cashinData: data, isLoadingCashin: isLoading }
}
